import React from "react";
import Title from "../../../components/Title";
import util from "../../../assets/text-util1.svg";
import box from "../../../assets/tax-bg.svg";
import util2 from "../../../assets/tax-utils2.png";

const Tax = () => {
  return (
    <div>
      <div className="container py-14 md:py-20">
        <Title text="TAX" image={util} center iconCenter />

        <div className="grid md:grid-cols-2 gap-10 md:gap-20 mt-20 relative">
          <img
            src={util2}
            className="absolute md:block hidden top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
            alt=""
          />
          <div className="relative">
            <p className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center text-sm md:text-xl">
              <span>3% Marketing</span>
              <br />
              <span>3% Developer</span>
            </p>
            <h2 className="text-xl font-medium md:text-5xl absolute top-1/2 left-0 -translate-x-1/2 -translate-y-1/2 text-green-500 ">
              Buy
            </h2>
            <img src={box} alt="" className="w-full" />
          </div>
          <div className="relative">
            <p className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center text-sm md:text-xl">
              <span>6% Marketing</span>
              <br />
              <span>3% Developer</span>
            </p>
            <h2 className="text-xl md:text-5xl absolute top-1/2 left-0 -translate-x-1/2 -translate-y-1/2 text-red-500 font-medium">
              Sell
            </h2>
            <img src={box} alt="" className="w-full" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tax;
